/**
 * Zentrale App-Konfiguration
 * Verwendet Umgebungsvariablen aus .env
 */

export const APP_CONFIG = {
  /**
   * Basis-URL der Anwendung
   * Wird aus Umgebungsvariable gelesen, fällt zurück auf aktuelle Domain
   */
  baseUrl: import.meta.env.VITE_APP_URL || (
    typeof window !== 'undefined' 
      ? `${window.location.protocol}//${window.location.host}`
      : 'https://reitsberger.de'
  ),
  
  /**
   * App-Name
   */
  appName: import.meta.env.VITE_APP_NAME || 'Maximilian Reitsberger Portfolio',
  
  /**
   * Gibt die absolute URL für einen relativen Pfad zurück
   */
  getAbsoluteUrl(path: string): string {
    // Wenn bereits absolute URL, zurückgeben
    if (path.startsWith('http://') || path.startsWith('https://')) {
      return path
    }
    
    // Stelle sicher, dass path mit / beginnt
    const normalizedPath = path.startsWith('/') ? path : `/${path}`
    
    return `${this.baseUrl}${normalizedPath}`
  }
} as const

export default APP_CONFIG














